import { useEffect } from 'react'
import styles from './Toast.module.css'

export type ToastSeverity = 'error' | 'success' | 'info' | 'warning'

interface ToastProps {
  message: string
  severity?: ToastSeverity
  onClose: () => void
  durationMs?: number
}

export default function Toast({
  message,
  severity = 'info',
  onClose,
  durationMs = 5000,
}: ToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, durationMs)
    return () => window.clearTimeout(timer)
  }, [durationMs, onClose])

  return (
    <div className={[styles.toast, styles[severity]].join(' ')} role="status">
      <span className={styles.message}>{message}</span>
      <button type="button" className={styles.close} onClick={onClose} aria-label="Dismiss">
        ×
      </button>
    </div>
  )
}
